import type { SideBarLink } from '../../../navRouteArray'

interface Props {
    link: SideBarLink
    roles: string[]
    isEdgeAdmin: boolean
    hasReportRole: boolean
    mobileView: boolean
    isAuctionAdmin: boolean
    ldFlags?: Record<string, unknown>
}

// TODO: Continue adding tests for remaining case statements that do not currently have tests.
// Missing tests for case 1,4,5
const showHideLink = ({
    link,
    roles,
    isEdgeAdmin,
    hasReportRole,
    mobileView,
    isAuctionAdmin,
    ldFlags,
}: Props): boolean => {
    if (link.ldFlag && !ldFlags?.[link.ldFlag]) return false

    // Respect explicit mobile/desktop visibility before role-based checks.
    if (mobileView && link.showOnMobile === false) return false
    if (!mobileView && link.showOnMobile === true) return false

    switch (true) {
        case link.allowEdgeAdmin && isEdgeAdmin:
            return true
        // checks link.showOnMobile === true and that the user is in mobile view.
        case !!link.showOnMobile && mobileView && !!link.reportRoles:
            return !!link.showOnMobile && (hasReportRole || isEdgeAdmin)
        // checks link.showOnMobile === false and that user is not in mobile view.
        case link.showOnMobile === false && !mobileView && !!link.reportRoles:
            return link.showOnMobile === false && (hasReportRole || isEdgeAdmin)
        // checks for either userAdmin or edgeAdmin to show ADMIN TAB
        case link.allowAuctionAdmin && isAuctionAdmin:
            return true
        // checks whether the user has FEATURE_FLAG_3 aka(Scanner)
        case !!link.singularRole:
            if (link.reportRoles && link.singularRole) {
                return hasReportRole && roles.includes(link.singularRole)
            }
            return !!link.singularRole && roles.includes(link.singularRole)
        default:
            return false
    }
}
export default showHideLink
